module.exports = __webpack_public_path__ + "img/img_04.5b854820.jpg";